const GLOBAL_TASKS = [
  { name: "Complete the Leagues Tutorial", tier: "Easy", points: 10, global: true },
  { name: "Open the Leagues Menu", tier: "Easy", points: 10, global: true },
  { name: "Defeat a Hill Giant", tier: "Easy", points: 10, global: true },
  { name: "Reach Combat Level 50", tier: "Medium", points: 30, global: true },
  { name: "Use the Protect from Melee Prayer", tier: "Medium", points: 30, global: true },
  { name: "Kill 1 unique Echo Boss", tier: "Hard", points: 80, global: true },
  { name: "Kill 2 unique Echo Bosses", tier: "Hard", points: 80, global: true },
  { name: "Kill 3 unique Echo Bosses", tier: "Hard", points: 80, global: true },
  { name: "Kill 4 unique Echo Bosses", tier: "Elite", points: 200, global: true },
];

export const UNIVERSAL_REGIONS = [
  {
    name: "Varlamore",
    icon: '',
    pvm: ["Fortis Colosseum","Moons of Peril","Amoxliatl","Hueycoatl","Vardorvis","Doom of Mokhaiotl"],
    drops: [
      "Eclipse atlatl",
      "Dual macuahuitl",
      "Blue moon spear",
      "Glacial temotli",
      "Pendant of ates",
      "Sulphur blades",
      "Hueycoatl hide",
      "Tome of earth",
      "Dragon hunter wand",
      "Soulreaper axe",
      "Ultor ring",
      "Virtus robes",
      "Awakener's orb",
      "Huntsman's kit",
      "Avernic treads",
      "Eye of ayak",
      "Echo boots",
      "Sunfire fanatic armour",
      "Tonalztics of ralos",
    ],
    quests: [
      "Heart of Darkness Twilight's Promise Children of the Sun",
      "At First Light Eagles' Peak",
    ],
    slayer: [
      "Jellies (57 - 126)",
      "Wyrms (3 - 126)",
    ],
    settlements: [
      "Civitas illa Fortis",
      "Avium Savannah",
      "Cam Torum",
      "Ralos Rise",
      "Darkfrost",
      "Aldarin",
      "Twilight Temple",
      "The Stranglewood (accessible via a league navigator in northern Varlamore)",
      "Ruins of Tapoyauik",
    ],
    activities: [
      "House robbery",
      "Calcified mining",
      "Blessed bone shards",
      "Hunter's guild with Hunter rumours",
      "Mastering Mixology Herblore activity",
      "Colossal Wyrm Agility Course",
      "Crafting sunfire runes",
    ],
    skills: { prayer: 2, fletching: 1, herblore: 1, woodcutting: 1, hunter: 2 },
    extras: { seed_access: 1, ammo_source: 1, limpwurt: 3, eye_of_newt: 3, prayer_pot_primary: 2, prayer_pot_secondary: 1, anti_venoms_primary: 2, allotment_patches: 2, tree_patches: 1, hardwood_patches: 1 },
    spellbook: [],
    prayer: [],
    tasks: [
      ...GLOBAL_TASKS,
      { name: "1 Hueycoatl Kill", tier: "Hard", points: 80 },
      { name: "Complete Wave 12 of Fortis Colosseum", tier: "Elite", points: 200 },
      { name: "Defeat Awakened Vardorvis", tier: "Elite", points: 200 },
      { name: "Equip Avernic Treads", tier: "Elite", points: 200 },
    ],
  },
  {
    name: "Karamja",
    icon: '',
    pvm: ["Fight Caves","Inferno"],
    drops: [
      "Obsidian helmet",
      "Obsidian platebody",
      "Obsidian platelegs",
      "Tzhaar-ket-om",
      "Toktz-ket-xil",
      "Obsidian cape",
      "Toktz-xil-ul",
      "Toktz-mej-tal",
      "Toktz-xil-ak",
      "Toktz-xil-ek",
      "Draconic visage",
      "Gout tuber",
      "Rune limbs",
      "onyx",
    ],
    quests: [
      "Shilo Village Jungle Potion",
    ],
    slayer: [
      "Zombies (10 - 50)",
      "Fire Giants (65 - 126)",
      "Moss Giants (40 - 100)",
      "Red Dragons (65 - 126)",
      "Greater Demons (70 - 126)",
      "Iron Dragons (80 - 126)",
      "Steel Dragons (85 - 126)",
      "Harpie Bug Swarms (45 - 85)",
      "Tzhaar (60 - 126)",
    ],
    settlements: [
      "Brimhaven",
      "Karamja Ship Yard",
      "Musa Point",
      "Shilo Village",
      "Tai Bwo Wannai",
      "Mor-Ul-Rek",
    ],
    activities: [
      "Brimhaven Agility Arena",
      "Brimhaven House Portal",
      "Calquat tree patch",
      "Fishing infernal eel",
      "Fruit tree patch north of Brimhaven",
      "Fishing karambwan",
      "Nature Altar",
      "Tai Bwo Wannai Cleanup",
      "Teak and Mahogany woodcutting",
      "Tzhaar pickpocketing",
      "Thieving from the gem stall in Mor-Ul-Rek",
      "Uncut gems from the Shilo Village mine",
    ],
    skills: {},
    extras: { food_source: 1, limpwurt: 1, prayer_pot_primary: 1, prayer_pot_secondary: 1 },
    spellbook: [],
    prayer: [],
    tasks: [
      ...GLOBAL_TASKS,
      { name: "Defeat a Steel Dragon on Karamja", tier: "Medium", points: 30 },
      { name: "Defeat a TzHaar", tier: "Medium", points: 30 },
      { name: "Complete Tzhaar-Ket-Rek's third challenge", tier: "Hard", points: 80 },
      { name: "Equip a Fire Cape", tier: "Elite", points: 200 },
      { name: "Complete Tzhaar-Ket-Rek's Special challenge", tier: "Master", points: 400 },
      { name: "Equip an Infernal Cape", tier: "Master", points: 400 },
    ],
  },
];

export const UNLOCKABLE_REGIONS = [
  {
    name: "Asgarnia",
    icon: '',
    pvm: ["Cerberus","Kree'arra","Graardor","Zilyana","K'ril Tsutsaroth","Nex","Whisperer","Giant Mole"],
    drops: [
      "Dragon defender",
      "Primordial crystal",
      "Pegasian crystal",
      "Eternal boots",
      "Smouldering stone",
      "Armadyl armour",
      "Armadyl hilt",
      "Bandos armour",
      "Bandos hilt",
      "Saradomin sword",
      "Armadyl crossbow",
      "Steam battlestaff",
      "Zamorakian spear",
      "Staff of the dead",
      "Godsword shard",
      "Dragon boots",
      "Zaryte vambraces",
      "Nihil horn",
      "Torva armour",
      "Ancient hilt",
      "Bellator ring",
      "Soulreaper axe",
      "Virtus robes",
      "Awakener's orb",
      "Giantsoul amulet",
      "Deadeye prayer scroll",
      "Mystic vigour prayer scroll",
      "Flippers",
      "Void armor set",
      "Echo Dagger",
    ],
    quests: [
      "Merlin's Crystal",
      "My Arm's Big Adventure Eadgar's Ruse Troll Stronghold Death Plateau",
      "The Feud",
      "Dwarf Cannon",
    ],
    slayer: [
      "Trolls (60 - 126)",
      "Ogres (40 - 90)",
      "Black Demons (80 - 126)",
      "Hellhounds (75 - 126)",
      "Bloodveld (50 - 126)",
      "Skeletal Wyverns (70 - 126)",
      "Spiritual Creatures (60 - 100)",
      "Sourhogs (3 - 126)",
    ],
    settlements: [
      "Burthorpe",
      "The Ruins of Camdozaal",
      "Ice Mountain",
      "Dwarven Mine",
      "Entrana",
      "Falador",
      "Goblin Village",
      "God Wars Dungeon",
      "Port Sarim",
      "Rimmington",
      "Taverley",
      "Troll Stronghold",
      "Void Knights' Outpost",
    ],
    activities: [
      "Crafting Guild",
      "Falador Rooftop Agility Course",
      "Falador tree patch",
      "Falador allotment patch",
      "Fire obelisk and Water obelisk",
      "Heroes' Guild",
      "Motherlode Mine",
      "Rimmington house portal",
      "Rogues' Den",
      "Air, body, law, and Mind Altars",
      "Taverley house portal",
      "Taverley tree patch",
      "Troll Stronghold herb patch",
    ],
    skills: { construction: 1 },
    extras: { ammo_source: 2, eye_of_newt: 3, prayer_pot_primary: 1, prayer_pot_secondary: 1, herb_patches: 2, allotment_patches: 2, bush_patches: 1, tree_patches: 2 },
    spellbook: [],
    prayer: [],
    prayerUnlocks: ['Chivalry', 'Piety', 'Deadeye', 'Mystic Vigour'],
    tasks: [
      ...GLOBAL_TASKS,
      { name: "Defeat a Troll in Asgarnia", tier: "Easy", points: 10 },
      { name: "Defeat the Royal Titans solo", tier: "Hard", points: 80 },
      { name: "Equip a Dragon Defender", tier: "Hard", points: 80 },
      { name: "Defeat Awakened Whisperer", tier: "Elite", points: 200 },
      { name: "Equip a Godsword", tier: "Elite", points: 200 },
      { name: "Equip the Bellator Ring", tier: "Elite", points: 200 },
      { name: "Defeat Nex Solo", tier: "Master", points: 400 },
    ],
  },
  {
    name: "Fremennik",
    icon: '',
    pvm: ["Dagannoth Kings","Muspah","Vorkath","Duke Sucellus"],
    drops: [
      "Draconic visage",
      "Skeletal visage",
      "Dragonbone necklace",
      "Seers ring",
      "Berserker ring",
      "Warrior ring",
      "Archers ring",
      "Mud battlestaff",
      "Dragon Axe",
      "Basilisk jaw",
      "Leaf-bladed battleaxe",
      "Brine sabre",
      "Magus ring",
      "Soulreaper Axe",
      "Virtus mask",
      "Virtus robe top",
      "Virtus robe bottom",
      "Awakener's orb",
      "Ancient sceptre",
      "Venator shard",
      "Echo Helm",
    ],
    quests: [
      "Secrets of the North and all prerequisites (Note that this does not complete Desert Treasure I)",
      "Horror from the Deep Alfred Grimhand's Barcrawl Scorpion Catcher",
      "Dragon Slayer II Legends' Quest Family Crest",
      "Heroes' Quest Shield of Arrav",
      "Lost City",
      "Merlin's Crystal",
      "Dragon Slayer I",
      "Underground Pass Biohazard Plague City",
      "Waterfall Quest",
      "Dream Mentor Lunar Diplomacy The Fremennik Trials",
      "Lost City",
      "Rune Mysteries",
      "Shilo Village Jungle Potion",
      "Eadgar's Ruse Druidic Ritual",
      "Troll Stronghold Death Plateau",
      "A Tail of Two Cats Icthlarin's Little Helper Gertrude's Cat",
      "Animal Magnetism Ernest the Chicken",
      "Priest in Peril",
      "The Restless Ghost",
      "Ghosts Ahoy Priest in Peril",
      "The Restless Ghost",
      "Bone Voyage The Dig Site",
      "Client of Kourend",
      "Mountain Daughter",
      "The Fremennik Isles The Fremennik Trials",
      "Olaf's Quest",
    ],
    slayer: [
      "Trolls (60 - 126)",
      "Dagannoth (75 - 126)",
      "Turoth (60 - 100)",
      "Basilisks (40 - 126)",
      "Cockatrice (40 - 80)",
      "Kurask (65 - 126)",
      "Jellies (57 - 126)",
    ],
    settlements: [
      "Keldagrim",
      "Ghorrock Dungeon",
      "Lunar Isle",
      "Miscellania & Etceteria",
      "Neitiznot & Jatizso",
      "Rellekka",
      "The Island of Stone",
      "The Mountain Camp",
      "The Pirates' Cove",
      "Ungael",
      "Waterbirth Island",
      "Weiss (Requires completion of Making Friends with My Arm)",
    ],
    activities: [
      "Blast Furnace, operated by Dwarves Ice gloves will be placed in your bank upon region unlock and can be reclaimed from The Sage if lost",
      "Kingdom Management",
      "Penguin Agility Course",
      "Rellekka house portal",
      "Rellekka Rooftop Course",
      "Astral Altar",
      "Weiss herb patch",
    ],
    skills: { prayer: 1, construction: 1, smithing: 1 },
    extras: { gp_source: 2, food_source: 2, travel: 2, ammo_source: 3, limpwurt: 3, antifires_secondary: 3, prayer_pot_primary: 1, prayer_pot_secondary: 1, herb_patches: 1, bush_patches: 1 },
    spellbook: ['Lunar'],
    prayer: [],
    tasks: [
      ...GLOBAL_TASKS,
      { name: "Defeat a Cockatrice in the Fremennik Province", tier: "Easy", points: 10 },
      { name: "Kill 8 penguins within 5 seconds", tier: "Medium", points: 30 },
      { name: "Defeat Phantom Muspah", tier: "Hard", points: 80 },
      { name: "Defeat Basilisk Knight", tier: "Hard", points: 80 },
      { name: "Defeat Awakened Duke Sucellus", tier: "Elite", points: 200 },
      { name: "Defeat Vorkath 5 Times Without Special Damage", tier: "Elite", points: 200 },
      { name: "Equip the Magus Ring", tier: "Elite", points: 200 },
    ],
  },
  {
    name: "Kandarin",
    icon: '',
    pvm: ["Kraken","Thermonuclear Smoke Devil","Demonic Gorillas"],
    drops: [
      "Zenyte shard",
      "Ballista limbs",
      "Ballista spring",
      "Light frame",
      "Heavy frame",
      "Trident of the seas",
      "Kraken tentacle",
      "Occult necklace",
      "Smoke battlestaff",
      "Dragon chainbody",
      "Dragon full helm",
      "Draconic visage",
      "Mist battlestaff",
      "Warped sceptre",
      "Angler's outfit",
      "Echo Trident",
      "Devil's Element",
    ],
    quests: [
      "King's Ransom Black Knight's Fortress",
      "Holy Grail Merlin's Crystal",
      "Murder Mystery",
      "One Small Favour Rune Mysteries",
      "Shilo Village Jungle Potion Druidic Ritual",
      "Murder Mystery",
      "Monkey Madness II Enlightened Journey",
      "The Eyes of Glouphrie",
      "Recipe for Disaster/Freeing King Awowogei Monkey Madness I The Grand Tree",
      "Tree Gnome Village",
      "Recipe for Disaster/Another Cook's Quest Cook's Assistant",
      "Troll Stronghold Death Plateau",
      "Watchtower",
      "Swan Song Garden of Tranquillity Creature of Fenkenstrain",
      "The Rising Sun in Falador",
      "The Rusty Anchor in Port Sarim",
    ],
    slayer: [
      "Ogres (40 - 90)",
      "Black Demons (80 - 126)",
      "Hellhounds (75 - 126)",
      "Waterfiends (75 - 110)",
      "Cave Kraken (80 - 126)",
      "Mithril Dragons (3 - 126)",
      "Smoke Devils (85 - 126)",
    ],
    settlements: [
      "Ape Atoll",
      "Ardougne",
      "Barbarian Outpost",
      "Catherby",
      "Corsair Cove",
      "Gu'Tanoth",
      "Myths' Guild",
      "Piscatoris Fishing Colony",
      "Port Khazard",
      "Seers' Village",
      "Tree Gnome Stronghold",
      "Tree Gnome Village",
      "Yanille",
    ],
    activities: [
      "Ardougne Market thieving",
      "Ardougne Rooftop Course",
      "Barbarian fishing",
      "Barbarian Outpost Agility Course",
      "Fishing in Catherby",
      "Chompy bird hunting",
      "Hunter training in Feldip Hills",
      "Fishing Trawler",
      "Gnome Stronghold Agility Course",
      "Fishing Guild",
      "Myths' Guild",
      "Piscatoris Hunter area",
      "Ourania Altar",
      "Wrath Altar",
      "Seers' Village Rooftop Course",
      "Access to spirit tree",
      "Tower of Life",
      "Yanille house portal",
    ],
    skills: { runecrafting: 1, thieving: 1 },
    extras: { food_source: 3, travel: 1, ammo_source: 1, eye_of_newt: 3, prayer_pot_primary: 2, herb_patches: 2, allotment_patches: 4, bush_patches: 1, tree_patches: 1 },
    spellbook: [],
    prayer: [],
    tasks: [
      ...GLOBAL_TASKS,
      { name: "Defeat a Demonic Gorilla", tier: "Hard", points: 80 },
      { name: "Defeat a Mithril Dragon", tier: "Hard", points: 80 },
      { name: "Defeat the Kraken Boss 50 Times", tier: "Hard", points: 80 },
      { name: "Equip a Trident of the Seas", tier: "Hard", points: 80 },
      { name: "Equip Some Zenyte Jewelry", tier: "Elite", points: 200 },
      { name: "Equip an Abyssal Tentacle", tier: "Elite", points: 200 },
      { name: "Equip an Occult Necklace", tier: "Elite", points: 200 },
    ],
  },
  {
    name: "Desert",
    icon: '',
    pvm: ["Tempoross","Kalphite Queen","Leviathan","Tombs of Amascut"],
    drops: [
      "Osmumten's fang",
      "Lightbearer",
      "Elidinis' ward",
      "Masori mask",
      "Masori body",
      "Masori chaps",
      "Mega Rare Voucher",
      "Dragon pickaxe",
      "Dragon 2h sword",
      "Dust battlestaff",
      "Venator ring",
      "Soulreaper axe ",
      "Virtus mask",
      "Virtus robe top",
      "Virtus robe bottom",
      "Awakener's orb",
      "Tome of water",
      "Dragon harpoon",
      "Abyssal needle",
      "Abyssal lantern",
      "Abyssal dye",
    ],
    quests: [
      "Prince Ali Rescue",
      "Desert Treasure II Desert Treasure I The Dig Site",
      "Temple of Ikov",
      "The Tourist Trap",
      "Troll Stronghold Death Plateau",
      "Priest in Peril",
      "Waterfall Quest",
      "Secrets of the North Making Friends with My Arm My Arm's Big Adventure Eadgar's Ruse Druidic Ritual",
      "The Feud",
      "Jungle Potion",
      "Swan Song One Small Favour Rune Mysteries",
      "Shilo Village",
      "Garden of Tranquillity Creature of Fenkenstrain The Restless Ghost",
      "Cold War",
      "Romeo & Juliet",
      "The General's Shadow Curse of the Empty Lord, for full ghostly robes",
      "Fight Arena",
      "Devious Minds Wanted! Recruitment Drive Black Knights' Fortress",
      "The Lost Tribe Goblin Diplomacy",
      "Rune Mysteries",
      "Doric's Quest",
      "Enter the Abyss",
      "Hazeel Cult",
      "Enakhra's Lament",
      "Temple of the Eye Enter the Abyss",
      "The Garden of Death",
      "Below Ice Mountain",
      "His Faithful Servants",
      "Icthlarin's Little Helper Gertrude's Cat",
    ],
    slayer: [
      "Dust Devils (70 - 126)",
      "Kalphite (15 - 126)",
      "Bandits (3 - 126)",
    ],
    settlements: [
      "Bandit Camp",
      "Necropolis",
      "Ruins of Unkah",
      "Bedabin Camp",
      "Desert Mining Camp",
      "Nardah",
      "Pollnivneach",
      "Ruins of Uzer",
      "Uzer Oasis",
      "Giants' Plateau",
      "Sophanem",
    ],
    activities: [
      "Agility Pyramid",
      "Mage Training Arena",
      "Giants' Foundry",
      "Guardians of the Rift",
      "Elidinis Statuette in Nardah",
      "Pollnivneach Blackjacking",
      "Pollnivneach house portal",
      "Pollnivneach Rooftop Course",
      "Pyramid Plunder",
      "Fire Altar",
      "Mining in the Bandit Camp Quarry",
      "Sandstorm Machine",
      "Sorceress's Garden",
      "Zahur's Herblore Services",
    ],
    skills: { runecrafting: 1, thieving: 1, crafting: 1, smithing: 1, fishing: 1 },
    extras: { travel: 1, ammo_source: 3, mega_rares: 1 },
    spellbook: ['Ancient'],
    prayer: [],
    tasks: [
      ...GLOBAL_TASKS,
      { name: "Set a mummy ablaze", tier: "Easy", points: 10 },
      { name: "Cast Ice Barrage", tier: "Elite", points: 200 },
      { name: "Defeat Awakened Leviathan", tier: "Elite", points: 200 },
      { name: "Equip a Dragon Chainbody in the Kharidian Desert", tier: "Elite", points: 200 },
      { name: "Equip a Piece of Masori Armour", tier: "Elite", points: 200 },
      { name: "Equip the Venator Ring", tier: "Elite", points: 200 },
      { name: "Equip Osmumten's Fang (or)", tier: "Master", points: 400 },
    ],
  },
  {
    name: "Morytania",
    icon: '',
    pvm: ["Grotesque Guardians","Araxxor","Nightmare","Barrows","Theatre of Blood"],
    drops: [
      "Barrows armour sets",
      "Granite gloves",
      "Granite ring",
      "Granite hammer",
      "Guardian boots",
      "Ring of endurance (uncharged)",
      "Mega Rare Voucher",
      "Sanguinesti staff",
      "Ghrazi rapier",
      "Justiciar armor",
      "Avernic defender",
      "Nightmare staff",
      "Inquisitor's great helm",
      "Inquisitor's hauberk",
      "Inquisitor's plateskirt",
      "Inquisitor's mace",
      "Eldritch orb",
      "Harmonised orb",
      "Volatile orb",
      "Black mask",
      "Blood shard",
      "Amulet of rancour",
      "Noxious halberd pieces",
      "Aranea boots",
      "Granite maul",
      "Echo Staff",
    ],
    quests: [
      "Ghosts Ahoy",
      "A Taste of Hope Darkness of Hallowvale In Aid of the Myreque In Search of the Myreque Nature Spirit Priest in Peril",
      "Restless Ghost",
      "The Great Brain Robbery Creature of Fenkenstrain",
      "Cabin Fever Pirate's Treasure",
      "Rum Deal Zogre Flesh Eaters Big Chompy Bird Hunting",
      "Recipe for Disaster/Freeing Pirate Pete Recipe for Disaster/Another Cook's Quest Cook's Assistant",
    ],
    slayer: [
      "Vampyres (35 - 100)",
      "Banshees (20 - 50)",
      "Gargoyles (80 - 126)",
      "Bloodveld (50 - 126)",
      "Nechryael (85 - 126)",
      "Cave Horrors (85 - 126)",
    ],
    settlements: [
      "Burgh de Rott",
      "Canifis",
      "Darkmeyer",
      "Meiyerditch",
      "Mort'ton",
      "Mos Le'Harmless",
      "Port Phasmatys",
      "Slepe",
      "Ver Sinhaza",
    ],
    activities: [
      "Canifis Rooftop Course",
      "Daeyalt Essence mining",
      "Ectofuntus prayer training",
      "Hallowed Sepulchre",
      "Harmony Island herb patch",
      "Port Phasmatys allotment patch",
      "Temple Trekking",
      "True Blood Altar (A blood talisman can be purchased from the Canifis General Store)",
      "Vyrelord pickpocketing",
      "Werewolf Agility Course",
    ],
    skills: { slayer: 1 },
    extras: { limpwurt: 3, anti_venoms_primary: 2, anti_venoms_secondary: 2, prayer_pot_primary: 1, herb_patches: 2, allotment_patches: 2, mega_rares: 1 },
    spellbook: [],
    prayer: [],
    tasks: [
      ...GLOBAL_TASKS,
      { name: "Defeat a Werewolf in Morytania", tier: "Easy", points: 10 },
      { name: "1 Araxxor Kill", tier: "Hard", points: 80 },
      { name: "Assemble a Slayer Helm", tier: "Hard", points: 80 },
      { name: "Create an Amulet of Blood Fury", tier: "Hard", points: 80 },
      { name: "Equip any Full Barrows Armour Set", tier: "Hard", points: 80 },
      { name: "Complete the Theatre of Blood 25 Times", tier: "Elite", points: 200 },
      { name: "Defeat Phosani's Nightmare", tier: "Elite", points: 200 },
    ],
  },
  {
    name: "Tirannwn",
    icon: '',
    pvm: ["The Gauntlet","Zulrah","Zalcano"],
    drops: [
      "Crystal Body",
      "Crystal weapon seed",
      "Enhanced crystal weapon seed",
      "Crystal tool seed",
      "Zalcano shard",
      "Tanzanite fang",
      "Serpentine visage",
      "Toxic trident",
      "Uncut onyx",
      "Dark bow",
      "Dragonstone full helm",
      "Dragonstone platebody",
      "Dragonstone platelegs",
      "Enhanced crystal teleport seed",
      "Mist battlestaff",
      "Leaf-bladed battleaxe",
    ],
    quests: [
      "Song of the Elves Mourning's End Part II Mourning's End Part I Big Chompy Bird Hunting",
      "Sheep Herder",
      "Roving Elves Waterfall Quest",
      "Regicide Underground Pass Biohazard Plague City",
      "Making History Priest in Peril",
      "The Restless Ghost",
    ],
    slayer: [
      "Kurask (65 - 126)",
      "Bloodveld (50 - 126)",
      "Nechryael (85 - 126)",
      "Elves (70 - 126)",
      "Dark Beasts (90 - 126)",
      "Waterfiends (75 - 110)",
    ],
    settlements: [
      "Gwenith",
      "Iorwerth Camp",
      "Lletya",
      "Prifddinas",
      "Tyras Camp",
      "Zul-Andra",
    ],
    activities: [
      "Elven Crystal Chest",
      "Death Altar",
      "Lletya Fruit Tree Patch",
      "Prifddinas Allotment Patch",
      "Prifddinas Agility Course",
      "Prifddinas Crystal implings",
      "Prifddinas Hunter Grounds",
      "Prifddinas house portal",
      "Prifddinas Teak and Mahogany trees",
      "Sacred Eel fishing",
      "Zalcano",
      "Thieving Elves",
    ],
    skills: {},
    extras: { gp_source: 2, ammo_source: 1, white_berries: 1, eye_of_newt: 3, anti_venoms_primary: 2, anti_venoms_secondary: 3, allotment_patches: 2 },
    spellbook: [],
    prayer: [],
    tasks: [
      ...GLOBAL_TASKS,
      { name: "Kill a Black Dragon in Tirannwn", tier: "Medium", points: 30 },
      { name: "Complete the Corrupted Gauntlet", tier: "Hard", points: 80 },
      { name: "Defeat Zalcano", tier: "Hard", points: 80 },
      { name: "Equip a Dark Bow in Tirannwn", tier: "Hard", points: 80 },
      { name: "Craft a Toxic Blowpipe", tier: "Elite", points: 200 },
      { name: "Use a prayer altar to restore 90 prayer in Prifddinas", tier: "Elite", points: 200 },
      { name: "Equip a Corrupted Weapon", tier: "Master", points: 400 },
    ],
  },
  {
    name: "Wilderness",
    icon: '',
    pvm: ["King Black Dragon","Callisto","Venenatis","Vet'ion","Corporeal Beast","Scorpia","Chaos Elemental","Chaos Fanatic","Crazy Archaeologist"],
    drops: [
      "Viggora's chainmace (u)",
      "Craw's bow (u)",
      "Thammaron's sceptre (u)",
      "Amulet of avarice",
      "Voidwaker",
      "Claws of Callisto",
      "Fangs of Venenatis",
      "Skull of Vet'ion",
      "Tyrannical ring",
      "Treasonous ring",
      "Ring of the gods",
      "Malediction ward",
      "Odium ward",
      "Dragon boots",
      "Dragon 2h sword",
      "Dragon pickaxe",
      "Dragon chainbody",
      "Abyssal whip",
      "Abyssal dagger",
      "Arcane sigil",
      "Spectral sigil",
      "Elysian sigil",
      "Dagon'hai",
      "Imbued God Capes",
      "Amulet of eternal glory",
      "Elder chaos robes",
      "Echo Crossbow",
    ],
    settlements: [
      "Bandit Camp",
      "Dark Warriors' Fortress",
      "Ferox Enclave",
      "The Mage Arena",
      "Rogues' Castle",
      "Pirates' Hideout",
    ],
    activities: [
      "Abyss Runecrafting (note: you cannot access altars that are in areas you haven't unlocked!)",
      "Air Obelisk",
      "Black chinchompa",
      "Black Salamander",
      "Dark Crab Fishing",
      "Earth Obelisk",
      "Fountain of Rune",
      "Chaos Altar",
      "Wilderness Agility Course",
      "Wilderness Resource Area",
      "Chest (Rogues' Castle)",
    ],
    skills: { prayer: 2, hunter: 1 },
    extras: { gp_source: 3, food_source: 2, limpwurt: 2, white_berries: 1, prayer_pot_primary: 2 },
    spellbook: [],
    prayer: [],
    tasks: [
      ...GLOBAL_TASKS,
      { name: "Defeat a Chaos Dwarf in the Wilderness", tier: "Easy", points: 10 },
      { name: "Defeat the Corporeal Beast", tier: "Hard", points: 80 },
      { name: "Equip a Dragon 2-Handed Sword in the Wilderness", tier: "Hard", points: 80 },
      { name: "Equip a Malediction Ward", tier: "Hard", points: 80 },
      { name: "Equip a Piece of the Dagon'Hai Set", tier: "Elite", points: 200 },
      { name: "Equip the Voidwaker", tier: "Elite", points: 200 },
      { name: "Imbue a God Cape", tier: "Elite", points: 200 },
    ],
  },
  {
    name: "Kourend",
    icon: '',
    pvm: ["Sarachnis","Hespori","Wintertodt","Alchemical Hydra","Chambers of Xeric","Lizardman Shamans"],
    drops: [
      "Mega Rare Vouvher",
      "Dragon hunter crossbow",
      "Ancestral hat",
      "Dragon claws",
      "Elder maul",
      "Kodai wand",
      "Dragon hunter lance",
      "Dragon warhammer",
      "Brimstone Ring",
      "Bonecrusher necklace",
      "Ferocious gloves",
      "Drake's claw",
      "Drake's tooth",
      "Dragon sword",
      "Dragon harpoon",
      "Dragon knife",
      "Dragon thrownaxe",
      "Sarachnis cudgel",
      "Bottomless compost bucket",
      "Abyssal whip",
      "Abyssal dagger",
      "Draconic visage",
      "Uncut onyx",
      "Oathplate armour",
      "Soulflame horn",
      "Echo Shortbow",
    ],
    quests: [
      "Client of Kourend X Marks the Spot",
      "A Kingdom Divided The Depths of Despair",
      "The Queen of Thieves",
      "The Ascent of Arceuus",
      "The Forsaken Tower",
      "Tale of the Righteous",
    ],
    slayer: [
      "Trolls (60 - 126)",
      "Black Demons (80 - 126)",
      "Hellhounds (75 - 126)",
      "Banshees (20 - 50)",
      "Bloodveld (50 - 126)",
      "Dust Devils (57 - 126)",
      "Jellies (57 - 126)",
      "Nechryael (85 - 126)",
      "Lizardmen (3 - 126)",
      "Wyrms (3 - 126)",
      "Drakes (3 - 126)",
      "Hydras (3 - 126)",
    ],
    settlements: [
      "Hosidius",
      "Arceuus",
      "Lovakengj",
      "Port Piscarilius",
      "Shayzien",
      "Kingstown",
      "Northern Tundras",
      "Kourend Woodland",
      "Mount Karuulm",
      "Kebos Swamp",
      "Mount Quidamortem",
    ],
    activities: [
      "Farming Guild",
      "Woodcutting Guild",
      "Arceuus Library",
      "Hosidius House Portal",
      "Hosidius farming patches",
      "Tithe Farm",
      "Lake Molch Aerial Fishing",
      "The Wintertodt",
      "Soul Altar and Blood Altar",
      "Blast Mine",
    ],
    skills: { runecrafting: 1, magic: 1, farming: 1, slayer: 1 },
    extras: { food_source: 2, ammo_source: 1, seed_access: 3, eye_of_newt: 3, prayer_pot_primary: 2, prayer_pot_secondary: 2, anti_venoms_primary: 2, antifires_primary: 2, herb_patches: 2, allotment_patches: 4, bush_patches: 1, mega_rares: 1, tree_patches: 1 },
    spellbook: ['Arceuus'],
    prayer: [],
    prayerUnlocks: ['Rigour', 'Augury'],
    tasks: [
      ...GLOBAL_TASKS,
      { name: "Open 1 Grubby Chest", tier: "Easy", points: 10 },
      { name: "150 Lizardmen Shaman Kills", tier: "Medium", points: 30 },
      { name: "1 Skotizo Kill", tier: "Hard", points: 80 },
      { name: "25 Chambers of Xeric", tier: "Hard", points: 80 },
      { name: "Equip a Dragon Hunter Lance", tier: "Elite", points: 200 },
      { name: "Equip a piece of Radiant Oathplate", tier: "Elite", points: 200 },
      { name: "Equip any Ancestral Piece", tier: "Elite", points: 200 },
    ],
  },
];

export const MAX_UNLOCKABLE_REGIONS = 3;
